import React, { useState, useEffect } from "react";
import { stateList } from "_helpers";

export function CenterAddressModal({ show, onClose, centerData, onSave }) {
  const [formData, setFormData] = useState(centerData || {});
  const [errors, setErrors] = useState([]);
  const [isFormValid, setIsFormValid] = useState(true);

  useEffect(() => {
    setIsFormValid(Object.values(errors).every((msg) => msg === ""));
  }, [errors]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (validationMap[name]) {
      const errorMsg = validationMap[name](value);
      setErrors((prev) => ({ ...prev, [name]: errorMsg }));
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => {
    if (!email || email.trim() === "") return ""; // No error for blank

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      return "Invalid email format.";
    }

    return ""; // Valid email
  };

  const validateIndianZipcode = (value) => {
    const pinRegex = /^[1-9][0-9]{5}$/;
    // if (!value) return "ZIP code is required";
    if (!pinRegex.test(value)) return "Invalid ZIP code format";
    return "";
  };

  const validateIndianPhoneNumber = (value) => {
    if (!value || value.trim() === "") return ""; // No error for blank
    const mobileRegex = /^[6-9]\d{9}$/;
    const landlineRegex = /^0\d{2,4}\d{6,8}$/;

    if (mobileRegex.test(value)) {
      return ""; // Valid mobile
    }
    if (landlineRegex.test(value)) {
      return ""; // Valid landline
    }
    return "Invalid phone number.";
  };

  const validationMap = {
    email: validateEmail,
    phone_no: validateIndianPhoneNumber,
    zipcode: validateIndianZipcode,
    state: (v) => (v ? "" : "State is required."),
  };

  // const validateAllFields = (data) => {
  //   const errors = {};
  //   for (const key in validationMap) {
  //     errors[key] = validationMap[key](data[key]);
  //   }
  //   return errors;
  // };

  const handleSave = () => {
    const errorMessages = Object.entries(errors)
      .filter(([_, msg]) => msg !== "")
      .map(([field, msg]) => `${field}: ${msg}`)
      .join("\n");

    if (errorMessages) {
      alert(errorMessages);
      return;
    }
    // Call onSave with the updated center data
    onSave(formData);
  };

  return (
    <div className="centered-modal" style={{zIndex:"21055"}}>
      <div className="modal-header pt-2">
          <span className="close" id="close-button" onClick={onClose}>&times;</span>
          <h6 className="mb-0"><i className="bi bi-person-circle"></i> Center Address: {formData?.center_name}</h6>
      </div>
      <div className="modal-body">
        <div className="modal-row">
          <div className="modal-column">
            <label>Name:</label>
            <input
              type="text"
              name="center_name"
              value={formData.center_name || ""}
              onChange={handleChange}
              className="modal-input"
            />
          </div>
        </div>
        <div className="modal-row">
          <div className="modal-column">
            <label>Address Line 1:</label>
            <input
              type="text"
              name="address1"
              value={formData.address1 || ""}
              onChange={handleChange}
              className="modal-input"
            />
          </div>

          <div className="modal-column">
            <label>Address Line 2:</label>
            <input
              type="text"
              name="address2"
              value={formData.address2 || ""}
              onChange={handleChange}
              className="modal-input"
            />
          </div>
        </div>

        <div className="modal-row">
          <div className="modal-column">
            <label>State:</label>
            <select
              name="state"
              value={formData.state || ""}
              onChange={handleChange}
              className="modal-input "
            >
              <option value="">Select a state</option>
              {stateList.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className="modal-column">
            <label>Zip Code:</label>
            <input
              type="text"
              name="zipcode"
              value={formData.zipcode || ""}
              onChange={handleChange}
              className="modal-input"
            />
            {errors.zipcode && (
              <span className="error-text">{errors.zipcode}</span>
            )}
          </div>
        </div>

        <div className="modal-row">
          <div className="modal-column">
            <label>Country:</label>
            <input
              type="text"
              name="country"
              value={formData.country || ""}
              onChange={handleChange}
              className="modal-input"
            />
          </div>

          <div className="modal-column">
            <label>Phone:</label>
            <input
              type="tel"
              name="phone_no"
              value={formData.phone_no || ""}
              onChange={handleChange}
              className="modal-input"
            />
            {errors.phone_no && (
              <span className="error-text">{errors.phone_no}</span>
            )}
          </div>
        </div>

        <div className="modal-row">
          <div className="modal-column">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
              className="modal-input"
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          
        </div>
      </div>

      <div className="modal-actions">
        <div className="col-lg-4 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnAddressSave" onClick={handleSave}> SAVE</button></div>
        <div className="col-lg-3 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnAddressClose" onClick={onClose}> CLOSE</button></div>
      </div>
    </div>
  );
}
